.overlay-header {  
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;
  padding: var(--cms-spacing-100);
  gap: var(--cms-spacing-100);
}

.overlay-headline-container {
  color: var(--cms-text-color);
  @include label-font-150;
  font-family: var(--cms-brandfont1);
}

.overlay-close-container {
  display: flex;
  cursor: pointer;
  position: absolute;
  right: var(--cms-spacing-100);
  top: var(--cms-spacing-050);
  padding: 0;
  border: 0;
  background: none;
  align-items: center;
  justify-content: center; 
  width: 2.75rem;
  height: 2.75rem;
  --cms-button-height: 2.75rem;
}

.overlay-image-wrapper {
  /* 
    No spacing-variable can be used for padding-top here, because in concept no spacing is defined.
    The spacing consists of the (absolute-positioned) close-button and a spacing of 050
  */
  padding: 3.25rem var(--cms-spacing-100) 0 var(--cms-spacing-100);
  margin: 0 auto;
  position: relative;
}

.overlay-image {
  position: relative;
}

:host {
  background: var(--cms-semanticColors-container-weak-background);
  overflow-y: visible;
  overflow-x: hidden;
  position: fixed;
  right: 0;
  top: 0;
  transition: all 0.3s ease-in;
  width: 0;
  z-index: 10;
  height: 100%;
}

.overlay-container-inner {
  --cms-grid-row-height: 100%;
  --cms-container-max-width: 100%;
  --cms-grid-gap: 0;
  @include cms-default-grid-container;
  max-width: 100%;
  padding: 0;
}

.overlay-container-inner>* {
  grid-area: var(--cms-default-grid-area);
}

.overlay-image-container {
  height: auto;
  
  /* Reset button styles */
  background: none;
  padding: 0;
  margin: 0;
  border: none;
}

.overlay-content-container {
  background: var(--cms-semanticColors-container-weak-background);
}

.overlay-content-wrapper {
  display: flex;
  flex-direction: column;
  gap: var(--cms-spacing-100);
  padding: var(--cms-spacing-100);
}

.separator {
  height: px-to-rem(1);
  background: var(--cms-semanticColors-base-weak-border);
  margin-bottom: 0;
}

@include media-width($breakpoint-sm) {
  .overlay-container-inner {
    --cms-default-grid-area: auto / auto / auto / span 6;
  }

  .overlay-image-container {
    position: fixed;
    height: 100%;
    left: 0;
    display: flex;
    align-items: flex-start;
  }

  .overlay-image-wrapper {
    width: calc(100% - var(--cms-spacing-400));
    padding: var(--cms-spacing-200) 0 0 0;
  }

  .overlay-header {    
    padding: var(--cms-spacing-100) var(--cms-spacing-100) var(--cms-spacing-100) var(--cms-spacing-200);
  }
  
  :host {
    overflow-y: hidden;
    background: var(--cms-modal-transparency);
  }
  
  .overlay-content-container {
    --cms-default-grid-area: auto / 7 / auto / span 6;
    position: relative;
    right: 0;
    top: 0;
    height: 100%;
    overflow: overlay;
  }
  
  .overlay-close-container {
    position: relative;
    right: auto;
    top: auto;
    margin: 0 -1rem -1rem;
    width: 3.25rem;
    min-width: 3.25rem;
    height: 3.25rem;
    --cms-button-height: 3.25rem;
    align-self: flex-end;
  }
  
  .separator {
    margin-bottom: var(--cms-spacing-100);
  }
}